<template>
  <v-layout>
    <v-flex shrink>
      <v-card width="250px" class="elevation-5 mb-3">
        <v-list class="py-0" style="background-color: #000">
          <v-list-tile>
            <v-list-tile-title
              style="text-align: center; font-size: 20px; color: white"
              >Weserve for Business</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
        <v-list dark class="py-0" style="background-color: #424242">
          <v-list-tile v-for="item in items" :key="item.title" :to="item.url">
            <v-list-tile-action>
              <v-icon>{{ item.action }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="white--text">
              {{ item.title }}
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      items: [
        {
          action: "mdi-newspaper-variant-outline",
          title: "Business List",
          url: "/weserve_admin_login/-/business/table",
        },
        {
          action: "mdi-note-text",
          title: "Action Log",
          url: "/weserve_admin_login/-/business/table-log",
        },
        {
          action: "mdi-briefcase-account",
          title: "Business Client ",
          url: "/weserve_admin_login/-/business/business-client",
        },
        {
          action: "mdi-briefcase-account",
          title: "Monitor Invoice",
          url: "/weserve_admin_login/-/business/monitor-invoice",
        },
      ],
    };
  },
};
</script>
<style scoped>
.circle {
  height: 25px;
  width: 25px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}
</style>
